const en_EN = {
  global: {
    reihenfolgeAendern: "Change order",
    bitteWarten: "Please wait",
    erledigt: "Done",
    fehler: "Error",
    umsatzauswertung: "Sales analysis",
    generelleEinstellungen: "General settings",
    sonstiges: "Other",
    keineDatenVorhanden: "No data available.",
    hinweis: "This table shows all previous sales (including today).",
    ansichtBearbeiten: "Edit view",
    monate: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    speichern: "Save",
    wirklichLoeschen: ["Should the record ", " really be deleted?"],
    alleFelderAusfuellen: "Please fill in all fields to continue.",
    diesesFeldAusfuellen: "Please fill in this field to continue.",
    datensatzExistiertNicht: "This record does not exist.",
    ok: "OK",
    abbrechen: "Cancel",
    suche: "Search",
    artikelnummer: "Article Number",
    hersteller: "Manufacturer",
    name: "Name",
    anlieferungsdatum: "Arrival Date",
    lagerdauer: "Storage Period",
    lagerort: "Storage Location",
    menge: "Quantity",
    reservierteMenge: "Reserved Quantity",
    einkaufspreis: "Purchase Price",
    wert: "Value",
    zeige: "Show",
    von: "of",
    eintraegen: "entries",
    tage: "days",
  },
  anAbmelden: {
    titel: "Sign in",
    anmelden: "Sign in",
    abmelden: "Sign out",
    email: "Your email address",
    passwort: "Your password",
    sprache: "Language",
    ungeueltigeEmail: "The email address is invalid.",
    keinPasswort: "No password entered.",
    ungeueltigesPasswort: "The password is invalid.",
    benutzerNichtGefunden: "No user record corresponds to this identifier.",
    benutzerDeaktiviert:
      "The user account has been disabled by an administrator.",
  },
  uebersicht: {
    titel: "Overview",
    umsatzMonat: {
      titel: "Sales this month (until yesterday)",
      umsatzIst: "Actual sales",
      umsatzSoll: "Target (linear)",
      hrVonUmsatzIst: "Forecast (projection)",
      zielFix: "Forecast (fixed)",
      zielerfuellungHr: "Fulfillment (projection)",
      zielerfuellungIst: "Fulfillment",
      zielerfuellungSoll: "Fulfillment (target)",
    },
    umsatzHeute: {
      titel: "Sales today",
      umsatzIst: "Actual sales",
      umsatzSoll: "Daily target (linear)",
      zielerfuellungTag: "Fulfillment",
      tageszielHrMonat: "Daily target (projection)",
    },
    auftraegeHeute: {
      titel: "Orders today",
      auftraegeAnzahl: "Number of orders",
      auftragswert: "Order value (sell-in)",
    },
  },
  herstellerumsaetze: {
    titel: "Business Units > Manufacturers",
    businessUnits: "Business Units",
    buErstellen: "Create business unit",
    buBearbeiten: "Edit business unit",
    name: "Name",
    monatsumsatzziele: "Monthly sales targets",
    monatsumsatzzieleHinweis:
      "Daily sales targets are automatically calculated when saving.",
    monatsumsatzzieleGanzeZahlenHinweis: "Enter only whole numbers!",
    hersteller: "Manufacturers",
    verfuegbareHersteller: "Available manufacturers",
    ausgewaehlteHersteller: "Selected manufacturers",
    laender: "Countries",
    verfuegbareLaender: "Available countries",
    ausgewaehlteLaender: "Selected countries",
    kunden: "Customers",
    verfuegbareKunden: "Available customers",
    ausgewaehlteKunden: "Selected customers",
    kundenWerdenNichtBeruecksichtigt:
      'Selected customers are <b class="text-danger">not</b> included in the analysis.',
  },
  kundenumsaetze: {
    titel: "Account Managers > Customers",
    kundenbetreuer: "Account manager",
    kundenbetreuerErstellen: "Create account manager",
    kundenbetreuerBearbeiten: "Edit account manager",
    vorname: "First name",
    nachname: "Last name",
    businessUnits: "Business Units",
    verfuegbareBusinessUnits: "Available business units",
    ausgewaehlteBusinessUnits: "Selected business units",
    kunden: "Customers",
    verfuegbareKunden: "Available customers",
    ausgewaehlteKunden: "Selected customers",
    laender: "Countries",
  },
  amazonumsaetze: {
    titel: "Amazon > Manufacturers",
    landErstellen: "Create country",
    landBearbeiten: "Edit country",
    name: "Name",
    monatsumsatzziele: "Monthly sales targets",
    monatsumsatzzieleHinweis:
      "Daily sales targets are automatically calculated when saving.",
    monatsumsatzzieleGanzeZahlenHinweis: "Enter only whole numbers!",
    kunden: "Customers",
    verfuegbareKunden: "Available customers",
    ausgewaehlteKunden: "Selected customers",
    hersteller: "Manufacturers",
    verfuegbareHersteller: "Available manufacturers",
    ausgewaehlteHersteller: "Selected manufacturers",
    laender: "Countries",
    verfuegbareLaender: "Available countries",
    ausgewaehlteLaender: "Selected countries",
  },
  umsatzauswertungTabelle: {
    kunde: "Customer",
    hersteller: "Manufacturers",
    umsatzIst: "Current sales volume (incl. today)",
    umsatzIstHeute: "Today's sales volume",
    umsatzSoll: "Target (incl. today)",
    umsatzZielMonat: "Sales target (month)",
    zielerreichung: "Target fulfillment (month)",
  },
  wareneingang: {
    titel: "Incoming goods",
    artikelnummer: "CL item no.",
    herstellernummer: "Manufacturer item no.",
    bezeichnung: "Description",
    weMenge: "Incoming",
    lager: "Stock",
    reserviert: "Reserved",
    frei: "Free",
    bestellt: "Ordered",
  },
  lagerwerte: {
    titel: "Stock of goods",
    name: "Name",
    stock: "Stock",
    reserved: "Reserved",
    ordered: "Ordered",
    reach: "Extrapolation",
    bearbeiten: "Edit stock of goods",
  },
  onTheRoad: {
    titel: "AJA - On the Road",
    herstellernummer: "Manufacturer item no.",
    weMenge: "On the road",
    ankunft: "Arrival",
    bearbeiten: "Import AJA",
  },
  generelleEinstellungenHersteller: {
    titel: "Manufacturers",
    herstellerImportieren: "Import CSV",
    herstellerExportieren: "Export CSV",
    herstellerErstellen: "Create manufacturer",
    herstellerBearbeiten: "Edit manufacturer",
    name: "Name",
    lieferantennummern: "Supplier numbers",
    monatsumsatzziele: "Monthly sales targets",
    monatsumsatzzieleHinweis:
      "Daily sales targets are automatically calculated when saving.",
    monatsumsatzzieleGanzeZahlenHinweis: "Enter only whole numbers!",
  },
  generelleEinstellungenKunden: {
    titel: "Customers",
    kundenImportieren: "Import CSV",
    kundenExportieren: "Export CSV",
    kundeErstellen: "Create customer",
    kundeBearbeiten: "Edit customer",
    name: "Name",
    kundennummer: "Customer number",
    monatsumsatzziele: "Monthly sales targets",
    monatsumsatzzieleHinweis:
      "Daily sales targets are automatically calculated when saving.",
    monatsumsatzzieleGanzeZahlenHinweis: "Enter only whole numbers!",
  },
  generelleEinstellungenLaender: {
    titel: "Countries",
    landErstellen: "Create country",
    landBearbeiten: "Edit country",
    land: "Country",
    laendercode: "Country code",
    laendercodeLink: "https://en.wikipedia.org/wiki/ISO_3166-1",
    laendercodeHinweis: [
      "Enter the country code according to ",
      " ISO 3166-1.",
      "",
    ],
  },
  herstellerkundenumsaetze: {
    titel: "Manufacturers > Customers",
    kundenbetreuerBearbeiten: "Edit",
    hersteller: "Manufacturers",
    kunden: "Customers",
    verfuegbareHersteller: "Available manufacturers",
    ausgewaehlteHersteller: "Selected manufacturers",
    verfuegbareKunden: "Available customers",
    ausgewaehlteKunden: "Selected customers",
    umsatzHeute: "Sales today",
    umsatzMonat: "Sales this month",
    erstellen: "Create",
    bearbeiten: "Edit",
    nurKundenWerdenBeruecksichtigt: "Only selected customers will be used.",
    herstellerkundenumsaetze: "Manufacturers-Customers sales",
  },
  bukundenherstellerumsaetze: {
    titel: "BU > Customers > Manufacturers",
    kundenbetreuerBearbeiten: "Edit",
    hersteller: "Manufacturers",
    kunden: "Customers",
    name: "Name",
    verfuegbareHersteller: "Available manufacturers",
    ausgewaehlteHersteller: "Selected manufacturers",
    verfuegbareKunden: "Available customers",
    ausgewaehlteKunden: "Selected customers",
    umsatzHeute: "Sales today",
    umsatzMonat: "Sales this month",
    erstellen: "Create",
    bearbeiten: "Edit",
    nurKundenWerdenBeruecksichtigt: "Only selected customers will be used.",
    bukundenherstellerumsaetze: "BU-Customers-Manufacturers sales",
  },
  altbestaende: {
    titel: "Old stocks",
    bearbeiten: "Import old stocks",
    filterNinetyPlusDays: "90+ days",
    filterOnehundredEightyPlusDays: "180+ days",
    filterOnePlusYears: "1+ years",
    filterTwoPlusYears: "2+ years",
    filterAll: "All",
    minimumStoragePeriod: "Minimum storage period",
    dateiAuswaehlen: "Select file or drag and drop here",
    dateiHierAblegen: "Drop file here",
    unterstuetzteFormate: "Supported formats: .txt (tab-separated)",
    verarbeitungLaeuft: "Processing...",
    vorschauErsteZeilen: "Preview of the first 5 rows:",
    datenPruefen: "Please check the data before importing.",
    spalte: "Column",
    zeilenImportieren: "Import rows",
    importiere: "Importing...",
    abbrechen: "Cancel",
    erfolgreichImportiert:
      "Successfully imported {count} rows into the oldStocks collection.",
    importAbgeschlossen:
      "Import completed: {success} successful, {errors} errors.",
    keineDatenZumImportieren: "No data available for import.",
    dateiEnthaeltKeineDaten: "The file contains no data.",
    fehlerBeimLesen:
      "Error reading the file. Please ensure it is a valid tab-separated txt file.",
    fehlerBeimImport: "Error importing the data. Please try again.",
    exportXLSX: "Export XLSX",
    exportDeluxeArticleList: "Export Deluxe Article List",
    headerLagerdauerTage: "Storage Period (Days)",
    gesamtartikel: "Total Articles",
    kritisch: "Critical (>365 days)",
    warnung: "Warning (180-365 days)",
    gesamtwert: "Total Value (Purchase Price)",
  },
  vizrt: {
    titel: "VIZRT Bonus-Program",
    kunde: "Customer",
    umsatzIst: "month STATE",
    umsatzQuartal: "quarter STATE",
    umsatzJahr: "year STATE",
    umsatzSollMonat: "month TARGET",
    umsatzSollQuartal: "quarter TARGET",
    umsatzSollJahr: "year TARGET"
  }
};

export default en_EN;
